import FormBase from "../FormBase";
import FormFieldBase from "../FormFieldBase";
import ValidationBase, { ValidationType } from "../ValidationBase";
import Professional from '../../models/Professional'
import MedicalLinkService from "../../services/MedicalLinkService";
import MedicalLink from "../../models/MedicalLink";
import OptionItem from "../../models/OptionItem";

export class ReRegistrationMedicalLinkFormItem {
    Id: number;
    OperationArea: string;
    OperationAreaValue: any;
    NumberRCE: string | undefined;
    TasyCode: number | undefined;
    RemoveTasy: boolean | undefined;

    constructor(Id: number, OperationArea: any, NumberRCE?: string) {
        this.Id = Id;
        this.OperationArea = OperationArea.Text;
        this.OperationAreaValue = OperationArea;
        this.NumberRCE = NumberRCE;
    }

    static NewInstance(): ReRegistrationMedicalLinkFormItem {
        return new ReRegistrationMedicalLinkFormItem(0, "", "");
    }

}

export default class ReRegistrationMedicalLinkForm implements FormBase {

    OperationArea: FormFieldBase;
    NumberRCE: FormFieldBase;
    FormItemList: ReRegistrationMedicalLinkFormItem[];
    FormRemoveList: ReRegistrationMedicalLinkFormItem[];
    FormItemToEdit: ReRegistrationMedicalLinkFormItem;

    constructor(OperationArea: string, NumberRCE: string) {

        this.OperationArea = new FormFieldBase(OperationArea, [], () => "", (value: any) => { this.InputChangeCustom(value) });
        this.NumberRCE = new FormFieldBase(NumberRCE, [], () => "", (value: any) => { this.InputChangeCustom(value) });
        this.FormItemList = new Array<ReRegistrationMedicalLinkFormItem>();
        this.FormRemoveList = new Array<ReRegistrationMedicalLinkFormItem>();
        this.FormItemToEdit = ReRegistrationMedicalLinkFormItem.NewInstance();
    }

    AddOrUpdateReRegistrationMedicalLinkFormItem() {

        this.OperationArea.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
        this.NumberRCE.Validations = [];

        this.OperationArea.Mandatory = true;
        this.NumberRCE.Mandatory = true;

        if (this.ValidateForm()) {

             //Insert
            if (this.FormItemToEdit === null || this.FormItemToEdit.Id === 0) {

                let item = new ReRegistrationMedicalLinkFormItem(
                    this.getNewId(),
                    this.OperationArea.Value,
                    this.NumberRCE.Value,
                )

                this.FormItemList.push(item);

            //Update  
            } else {
                for (let index = 0; index < this.FormItemList.length; index++) {
                    const element = this.FormItemList[index];
                    if (element.Id === this.FormItemToEdit.Id) {

                        let item = new ReRegistrationMedicalLinkFormItem(
                            element.Id,
                            this.OperationArea.Value,
                            this.NumberRCE.Value
                        )

                        item.RemoveTasy = element.RemoveTasy;
                        item.TasyCode = element.TasyCode;

                        this.FormItemList[index] = item;
                    }
                }
            }
            this.ResetForm();
        }
    }
    
    CallInsertOrUpdateApi(Professional: Professional): Promise<boolean> {
        if ((this.FormItemList !== null && this.FormItemList.length > 0) || (this.FormRemoveList !== null && this.FormRemoveList.length > 0)) {
            const dataJson = this.getJsonObjet();
            return MedicalLinkService.postInsertOrUpdateAcademic(dataJson, Professional.Id);
        } else {
            return Promise.resolve(true);
        }
    }

    async PreloadFormFromApi(requestId: string): Promise<any> {

        return await MedicalLinkService.CreateAndGetMedicalLinkFromTasy(requestId).then((data: MedicalLink[]) => {

            this.FormItemList = new Array<ReRegistrationMedicalLinkFormItem>();
            this.FormRemoveList = new Array<ReRegistrationMedicalLinkFormItem>();

            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                let optionItem: OptionItem | undefined = undefined;

                if (element.OperationAreaId !== undefined && element.OperationAreaValue !== undefined) {
                    optionItem = new OptionItem(element.OperationAreaId, element.OperationAreaValue, element.OperationAreaId.toString());
                }
                
                let item = new ReRegistrationMedicalLinkFormItem(
                    this.getNewId(),
                    optionItem,
                    element.NrRCE,
                )

                item.RemoveTasy = element.RemoveTasy;
                item.TasyCode = element.TasyCode;

                this.FormItemList.push(item);

            }

        });
    }

    EditReRegistrationMedicalLinkFormItem(id: number) {
        this.ResetForm();

        for (let index = 0; index < this.FormItemList.length; index++) {
            const element = this.FormItemList[index];

            if (element.Id === id) {
                this.FormItemToEdit = element;
                this.OperationArea.Value = this.FormItemToEdit.OperationAreaValue;
                this.NumberRCE.Value = this.FormItemToEdit.NumberRCE;
            }
        }
    }

    RemoveReRegistrationMedicalLinkFormItem(id: number) {
        for (let index = 0; index < this.FormItemList.length; index++) {
            const element = this.FormItemList[index];
            if (element.Id === id) {
                if(element.TasyCode === undefined || element.TasyCode === 0) {
                    this.FormItemList.splice(index, 1);
                }else{
                    element.RemoveTasy = true;
                    this.FormRemoveList.push(element);
                    this.FormItemList.splice(index, 1);
                }
            }
        }
    }

    ValidateToGoNextStep(): string {
        return "";
    }

    InputChangeCustom(Value: any): void {

        if (Value != null && Value !== "") {

            this.OperationArea.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
            this.NumberRCE.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];

            this.OperationArea.Mandatory = true;
            this.NumberRCE.Mandatory = true;

        } else {

            let propNames = Object.getOwnPropertyNames(this);

            let existFieldImputed = false;

            for (let index = 0; index < propNames.length; index++) {
                const element = propNames[index];
                const value = this.GetFieldByName(element).Value;

                if (value != null && value !== "" && value.toString().trim() !== "") {
                    existFieldImputed = true;
                }
            }

            if (existFieldImputed) {
                this.OperationArea.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
                this.NumberRCE.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];

                this.OperationArea.Mandatory = true;
                this.NumberRCE.Mandatory = true;
            } else {
                this.OperationArea.Validations = [];
                this.NumberRCE.Validations = [];
                this.OperationArea.Error = "";
                this.NumberRCE.Error = "";
                this.OperationArea.Mandatory = false;
                this.NumberRCE.Mandatory = false;
            }
        }
    }

    static NewInstance(): ReRegistrationMedicalLinkForm {
        return new ReRegistrationMedicalLinkForm("", "");
    }

    ValidateForm(): boolean {
        let propNames = Object.getOwnPropertyNames(this);

        let formIsValid = true;

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            const error = this.GetFieldByName(element).ValidateField();

            if (error !== null && error !== "") {
                formIsValid = false;
            }
        }

        return formIsValid;
    }

    ResetForm(): void {
        let propNames = Object.getOwnPropertyNames(this);
        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            this.GetFieldByName(element).Value = "";
            this.GetFieldByName(element).Error = "";
        }

        this.FormItemToEdit = ReRegistrationMedicalLinkFormItem.NewInstance();
    }

    GetFieldByName(name: string): FormFieldBase {
        switch (name) {
            case "OperationArea":
                return this.OperationArea
            case "NumberRCE":
                return this.NumberRCE

            default:
                return new FormFieldBase("", []);
        }
    }


    getNewId(): number {
        if (this.FormItemList.length > 0) {
            let maxId = Math.max.apply(Math, this.FormItemList.map(function (o) { return o.Id; }))
            return maxId + 1;
        } else {
            return 1;
        }
    }

    getJsonObjet(professionalId: number = 0) {

        let viewModelList: any[] = [];

        if (this.FormItemList != null && this.FormItemList.length > 0) {
            this.FormItemList.forEach((element: ReRegistrationMedicalLinkFormItem) => {
                viewModelList.push({
                    "professionalId": professionalId,
                    "operationAreaId": (element.OperationAreaValue.Id === 0 ? null : element.OperationAreaValue.Id),
                    "nrRCE": element.NumberRCE,
                    "tasyCode": element.TasyCode,
                    "removeTasy": element.RemoveTasy,
                })
            });
        }

        if (this.FormRemoveList !== null && this.FormRemoveList.length > 0) {
            this.FormRemoveList.forEach((element: ReRegistrationMedicalLinkFormItem) => {
                viewModelList.push({
                    "professionalId": professionalId,
                    "operationAreaId": (element.OperationAreaValue.Id === 0 ? null : element.OperationAreaValue.Id),
                    "nrRCE": element.NumberRCE,
                    "tasyCode": element.TasyCode,
                    "removeTasy": element.RemoveTasy,
                })
            });
        }

        return viewModelList;
    }
}